import React from 'react'
import { makeStyles } from '@material-ui/styles'
import PaperWithPadding from 'components/templates/PaperWithPadding'
import StoreLocatorWidget from '../organisms/StoreLocatorWidget'
import useInitialProps from '../../hooks/useStaticContext'

const useStyles = makeStyles({
  root: {
    width: 'fit-content',
  },
})

const StoreLocatorPage = ({ staticContext }) => {
  const { storeLocatorUrl, cardsCount, logo, title } =
    useInitialProps(staticContext)
  const classes = useStyles()

  return (
    <PaperWithPadding padding={0.5} className={classes.root}>
      <StoreLocatorWidget
        storeLocatorUrl={storeLocatorUrl}
        cardsCount={cardsCount}
        logo={logo}
        name={title}
      />
    </PaperWithPadding>
  )
}
export default StoreLocatorPage
